import { Observable, Subject, Subscription } from 'rxjs';

// Cette classe definit un Subject qui a pour particularite de declencher relayer les evenements d'un autre Observable source
// L'observable-source pouvant ici changer au cours du temps
export class SubjectRelay<E> extends Subject<E> {
	private subscription: Subscription | null = null;
	
	constructor() {
		super();
	}
	
	public registerSource(obs: Observable<E> | null | undefined) {
		if (this.subscription) {
			this.subscription.unsubscribe();
			this.subscription = null;
		}
		if (obs) {
			this.subscription = obs.subscribe(
				(data: E) => this.next(data)
			);
		}
	}
}